import {useCallback} from 'react'
import {useSearchParams} from 'react-router-dom'

export const GARDEN_PLAN_VARIANT_PARAM = 'gardenPlanVariant'

export function useGardenPlanVariantParam() {
  const [searchParams, setSearchParams] = useSearchParams()
  const gardenPlanVariantId = searchParams.get(GARDEN_PLAN_VARIANT_PARAM)

  const setGardenPlanVariantId = useCallback(
    (id: string | null) =>
      setSearchParams(
        (params) => {
          if (id) {
            params.set(GARDEN_PLAN_VARIANT_PARAM, id)
          } else {
            params.delete(GARDEN_PLAN_VARIANT_PARAM)
          }
          return params
        },
        {replace: true}
      ),
    [setSearchParams]
  )

  const withGardenPlanVariant = useCallback(
    (path: string) =>
      gardenPlanVariantId
        ? `${path}?${new URLSearchParams({[GARDEN_PLAN_VARIANT_PARAM]: gardenPlanVariantId})}`
        : path,
    [gardenPlanVariantId]
  )

  return {gardenPlanVariantId, setGardenPlanVariantId, withGardenPlanVariant}
}
